/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { QuoteScopeComputedValuesResource } from './';
import {
    QuoteScopeComputedValuesResourceFromJSON,
    QuoteScopeComputedValuesResourceFromJSONTyped,
    QuoteScopeComputedValuesResourceToJSON,
} from './';
import type { QuoteWorkRate } from './';
import {
    QuoteWorkRateFromJSON,
    QuoteWorkRateFromJSONTyped,
    QuoteWorkRateToJSON,
} from './';

/**
 * 
 * @export
 * @interface TimeAndMaterialsQuoteDetailsResource
 */
export interface TimeAndMaterialsQuoteDetailsResource {
    /**
     * 
     * @type {string}
     * @memberof TimeAndMaterialsQuoteDetailsResource
     */
    projectScope?: string;
    /**
     * 
     * @type {QuoteWorkRate}
     * @memberof TimeAndMaterialsQuoteDetailsResource
     */
    workRate?: QuoteWorkRate;
    /**
     * 
     * @type {Date}
     * @memberof TimeAndMaterialsQuoteDetailsResource
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TimeAndMaterialsQuoteDetailsResource
     */
    estimatedEndDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof TimeAndMaterialsQuoteDetailsResource
     */
    estimatedTotalWorkAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeAndMaterialsQuoteDetailsResource
     */
    vatPercent?: number;
    /**
     * 
     * @type {QuoteScopeComputedValuesResource}
     * @memberof TimeAndMaterialsQuoteDetailsResource
     */
    computedValues?: QuoteScopeComputedValuesResource;
}

/**
 * Check if a given object implements the TimeAndMaterialsQuoteDetailsResource interface.
 */
export function instanceOfTimeAndMaterialsQuoteDetailsResource(value: object): value is TimeAndMaterialsQuoteDetailsResource {
    return true;
}

export function TimeAndMaterialsQuoteDetailsResourceFromJSON(json: any): TimeAndMaterialsQuoteDetailsResource {
    return TimeAndMaterialsQuoteDetailsResourceFromJSONTyped(json, false);
}

export function TimeAndMaterialsQuoteDetailsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeAndMaterialsQuoteDetailsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'projectScope': json['projectScope'] == null ? undefined : json['projectScope'],
        'workRate': json['workRate'] == null ? undefined : QuoteWorkRateFromJSON(json['workRate']),
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'estimatedEndDate': json['estimatedEndDate'] == null ? undefined : (new Date(json['estimatedEndDate'])),
        'estimatedTotalWorkAmount': json['estimatedTotalWorkAmount'] == null ? undefined : json['estimatedTotalWorkAmount'],
        'vatPercent': json['vatPercent'] == null ? undefined : json['vatPercent'],
        'computedValues': json['computedValues'] == null ? undefined : QuoteScopeComputedValuesResourceFromJSON(json['computedValues']),
    };
}

export function TimeAndMaterialsQuoteDetailsResourceToJSON(value?: TimeAndMaterialsQuoteDetailsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'projectScope': value['projectScope'],
        'workRate': QuoteWorkRateToJSON(value['workRate']),
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString().substring(0,10)),
        'estimatedEndDate': value['estimatedEndDate'] == null ? undefined : ((value['estimatedEndDate']).toISOString().substring(0,10)),
        'estimatedTotalWorkAmount': value['estimatedTotalWorkAmount'],
        'vatPercent': value['vatPercent'],
        'computedValues': QuoteScopeComputedValuesResourceToJSON(value['computedValues']),
    };
}

